<template functional>
    <router-link :to="{ name: props.breadcrumbTo }">
      <button type="button" class="cancel-btn">
        <img class="icon" src='@/assets/images/payments/arrow_left_blue.png' />
        {{ props.cancelTitle }}
      </button>
    </router-link>
</template>

<script>
    export default {
        name: "FPCancelButton"
    }
</script>
